export default "__VITE_ASSET__19fe1429__"